export default "__VITE_ASSET__B5JK5XZV__"